<template>
  <div>
    <old-fav v-if="proplist.length === 0" />
    <div v-else-if="proplist.length > 0" class="c-container">

      <div v-if="isMapDisplayFlag || !isTablet" class="p-map">
        <search-list-google-map
          v-if="isMapReady"
          :center="mapCenterCoordinate"
          :makerList="coordinateList"
          :zoom="zoom"
        />
        <div v-else class="p-map__blank"></div>
      </div>
      <section class="p-list js-search-list" v-if="isPagerReady && (!isMapDisplayFlag || !isTablet)">
        <h1>お気に入り物件一覧</h1>
        <div class="p-list--sort">
          <div class="p-list--sort--count">
            {{count}}件
          </div>
          <div class="p-list--sortOrderBlock">
            <div class="p-list--sort--order">
              <h3>表示件数：</h3>
              <div class="u-selectWrapper u-selectWrapper__s">
                <select v-model="options.size" @change="update()">
                  <option value=10 >10件</option>
                  <option value=30 >30件</option>
                  <option value=50 >50件</option>
                </select>
              </div>
            </div>
            <div class="p-list--sort--order">
              <h3>並び替え：</h3>
              <div class="u-selectWrapper">
                <select v-model="options.order_fav" @change="viewTrigger(options.order_fav)">
                  <option v-for="(item, index) in optionList.order_fav" :key="index" :value="index">{{item.name}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <p style="color: red;" class="p-list--sort">※掲載が終了した物件は、自動的に一覧から無くなります。</p>
        <search-loading v-if="!isPropReady" />
        <search-list-body
          v-if="isPropReady & proplist.length > 0"
          class="p-list--outline"
          :proplist="proplistFav"
          :update="update"
          :size="options.size"
          :page="options.page"
          :count="count"
          :mode="mode"
        />
        <search-area-info class="p-list--area--outline" v-if="isAreaInfoDisplay" :info="areaInfo" />
        <common-breadcrumb class="p-list--breadcrumb--outline" :breadcrumbType="'favorite'" />
        <common-footer v-if="!isMapDisplayFlag" />
      </section>
    </div>
    <button class="p-swapDisplay" v-if="!isSearchBody" @click="isMapDisplayFlag = !isMapDisplayFlag">
      <img v-if="isMapDisplayFlag" src="@/assets/images/icon_list_bullet@2x.png">
      <img v-else src="@/assets/images/icon_map@2x.png">
      <span v-if="!isMapDisplayFlag">地図を表示</span>
      <span v-else>物件リスト</span>
    </button>
    <common-view-limited
      v-if="isViewLimited"
      :isViewLimited="isViewLimited"
      :directLink="directLink"
      @input="isViewLimited = $event"
    />
  </div>
</template>

<script>
import axios from 'axios';

import MixinUtil from '@/plugins/mixin-utils';
import MixinAPI from '@/plugins/mixin-api';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';
import MixinMeta from '@/plugins/mixin-meta';
import isMobile from '@/plugins/isMobile';

import selectOptions from '@/assets/json/selectOptions.json';

import OldFav from '@/components/favorite/Favorite';

import SearchLoading from '@/components/search/kodate/SearchLoading';
import SearchBarPc from '@/components/search/kodate/pc/SearchBar';
import SearchBarSp from '@/components/search/kodate/sp/SearchBar';
import SearchListBody from '@/components/search/kodate/SearchListBody';
import SearchListGoogleMap from '@/components/parts/SearchListGoogleMap';
import SearchAreaInfo from '@/components/search/kodate/SearchAreaInfo';
import CommonBreadcrumb from '@/components/parts/CommonBreadcrumb';
import CommonFooter from '@/components/parts/CommonFooter';
import CommonViewLimited from '@/components/parts/CommonViewLimited';

const querystring = window.location.search;
const query = [...new URLSearchParams(querystring).entries()]
  .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});

export default {
  name: 'FavoriteContentsNew',
  mixins: [MixinUtil, MixinAPI, MixinMeta, isMobile, BehaviorLogMixin],
  props: ['preflist'],
  components: {
    OldFav,
    SearchLoading,
    SearchBarPc,
    SearchBarSp,
    SearchListBody,
    SearchListGoogleMap,
    SearchAreaInfo,
    CommonBreadcrumb,
    CommonFooter,
    CommonViewLimited,
  },
  data() {
    return {
      mapCenterCoordinate: {
        lat: 0,
        lng: 0,
      },
      options: {
        prefcode: '0',
        citycode: '0',
        ask: false,
        byBus: false,
        layout: [],
        priceLow: 0,
        priceHigh: 999999999,
        landAreaLow: 0,
        landAreaHigh: 99999,
        buildingAreaLow: 0,
        buildingAreaHigh: 99999,
        walkin: 999,
        fw: '',
        size: 10,
        order: 0,
        page: 1,
      },
      conditions: [],
      pager: [],
      isPrev: false,
      isNext: false,
      isFirst: false,
      isLast: false,
      isPropReady: false,
      isMapReady: false,
      isPagerReady: false,
      isAreaInfoDisplay: false,
      isSearchBody: false,
      coordinateList: [],
      areaInfo: {},
      searchArea: '',
      proplist: [],
      unsortedAllFavorites: [],
      isMapDisplayFlag: false,
      isViewLimited: false,
      directLink: false,
      zoom: 10,
      mode: 'prod',
    };
  },
  created() {
    this.metaSetForDefault('bookmark');
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user;
    },
  },
  async mounted() {
    const favoriteMetaList = await this.retrieveFullWishList();
    if (query.zoom !== undefined) this.zoom = parseInt(query.zoom, 10);
    if (query.mode !== undefined) this.mode = query.mode;
    this.optionList = selectOptions;

    const fetchPromises = favoriteMetaList.map(async (a) => {
      try {
        return await this.getPropertyData(a.id);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(`Failed to retrieve property with id ${a.id}`);
        throw e;
      }
    });
    const finished = await Promise.allSettled(fetchPromises);
    this.unsortedAllFavorites = finished.filter(promise => promise.status === 'fulfilled' && promise.value).map(p => p.value.data);

    this.isPropReady = true;

    /* --物件データ取得-- */
    await this.querySearch();
  },
  methods: {
    async querySearch() {
      // 検索実行
      const r = this.unsortedAllFavorites;
      this.count = r.length;
      this.options.page = query.page ? parseInt(query.page, 10) : 1;
      this.options.size = query.size ? parseInt(query.size, 10) : 10;
      this.options.order_fav = query.order ? query.order : 0;
      this.proplist = this.updateList(r)
        .map((n) => {
          return {
            ...n,
            registered: new Date(n.registered),
            provided_at: new Date(n.provided_at),
            built_at_within: new Date(n.built_at_within),
            price_min: parseInt(n.price_min, 10),
            land_area_min: parseInt(n.land_area_min, 10),
            building_area_min: parseInt(n.building_area_min, 10),
            access_time_by_foot_1: parseInt(n.access_time_by_foot_1, 10),
          };
        })
        .sort(this.sortProps(this.optionList.sort[this.options.order_fav].field, this.optionList.sort[this.options.order_fav].order))
        .slice((this.options.page - 1) * this.options.size, this.options.page * this.options.size);
      /* eslint arrow-body-style: 0 */
      this.proplistFav = this.proplist.map((n) => {
        return { id: n.id, fields: n };
      });

      // 地図座標取得
      this.emptylist = [];
      await this.proplist.map(async (n) => {
        if (
          (n.location.latitude === undefined && n.location.longitude === undefined) ||
          (n.location.latitude.toString() === '0.0' && n.location.longitude.toString() === '0.0')
        ) {
          let url;
          if (process.env.VUE_APP_ENV === 'prod') {
            url = 'https://prod-api.yeah.ki-group.jp/real-estate-properties/';
          } else {
            url = 'https://stg-api.yeah.ki-group.jp/real-estate-properties/';
          }
          // await axios.get(`${url}${n.id}`).then(m => m.data.data);
          // this.accessOpenApi(url, n);
          this.emptylist.push(`${url}${n.id}`);
        } else if (parseInt(n.location.latitude, 10) !== 0 && parseInt(n.location.longitude, 10) !== 0) {
          this.coordinateList.push({
            position:
              {
                lat: Number(n.location.latitude),
                lng: Number(n.location.longitude),
              },
            id: n.id,
            title: n.name,
            image: n.image,
            price: n.price,
            layout: n.layout,
            area: n.building_area,
            priority: n.priority,
            media: n.media,
          });
        }
      });

      // this.loopAccessOpenApi(this.emptylist);
      this.loop(this.emptylist);

      // 中心座標取得
      if (this.coordinateList.length > 0) {
        this.mapCenterCoordinate = {
          lat: this.coordinateList.map(n => n.position.lat).reduce((a, b) => Number(a) + Number(b)) / this.coordinateList.length,
          lng: this.coordinateList.map(n => n.position.lng).reduce((a, b) => Number(a) + Number(b)) / this.coordinateList.length,
        };
        this.isMapReady = true;
      }
      this.isPagerReady = true;
    },
    sortProps(key, order = 'asc') {
      return (a, b) => {
        const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key];
        const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key];
        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return (
          (order === 'desc') ? (comparison * -1) : comparison
        );
      };
    },
    sleep() {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 100);
      });
    },
    async loop(list) {
      /* eslint no-await-in-loop: 0,no-restricted-syntax: 0 */
      for (const i of list) {
        await axios.get(i)
          .then(response => Promise.resolve(response))
          .catch(() => {
            // console.log(error);
          });
        await this.sleep();
      }
    },
    update(page = 1) {
      let url = location.origin;
      url += '/bookmark/';
      // page
      url += `?page=${page}`;
      // size
      url += `&size=${this.options.size}`;
      // order
      url += `&order=${this.options.order_fav}`;

      location.href = url;
    },
    updateList(list) {
      const ret = list.filter((n) => {
        const limit = new Date();
        limit.setDate(limit.getDate() - 15);
        return new Date(n.provided_at) > limit;
      });
      return ret;
    },
    viewTrigger() {
      this.update();
    },
  },
};

</script>

<style scoped lang="scss">

$sp-width: 346px;
$pc-width: 702px;

* {
  font-size: 14px;
}

.p-map {
  position: relative;
  width: calc(100%  - 742px);
  height:calc(100vh - 94px);
  &__blank {
    width: 100%;
    //100%が使えないため100vhからheader+navのheight固定値引き
    height: calc(100vh - 94px);
    background-color: lightgray;
  }
}
.p-list {
  width: 742px;
  height: calc(100vh - 94px);
  overflow:auto;
  background-color: #FFF;;
  h1 {
    margin: 20px auto 0;
    font-size: 18px;
    font-weight: bold;
    width: 702px;
  }
  &--condition {
    margin: 30px 15px 20px;
    display: flex;
    flex-wrap: wrap;
    li {
      height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #CCC;
      border-radius: 19px;
      padding: 0 20px;
      margin: 0 8px 8px 0;
      background-color: #FFF;
      cursor: pointer;
      img {
        margin-left:  16px;
      }
    }
  }
  &--sortOrderBlock {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 80%;
  }
  &--sort {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px auto 12px;
    width: $pc-width;
    &--order {
      display: flex;
      align-items: center;
    }
    &--count {
      font-family: "メイリオ", "Meiryo", sans-serif;
      width: 20%;
      color: #E83532;
      font-size: 16px;
      font-weight: bold;
    }
  }
  &--outline {
    max-width: $pc-width;
    margin: 0 20px;
  }
  &--noprops {
    height: calc(100vh - 719px);
    min-height: 100px;
    padding:0 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &--area--outline {
    width: $pc-width;
    margin: 20px auto;
  }
  &--breadcrumb--outline {
    width: $pc-width;
    margin: 20px auto;
  }
}

.p-swapDisplay {
  width: 138px;
  height: 52px;
  border: 2px solid #E83532;
  border-radius: 15px;
  background-color: #FFF;
  color: #E83532;
  display: none;
  position: fixed;
  bottom: 112px;
  left: calc(50% - 69px);
  z-index: 120;

  img {
    margin-right: 4px;
    height: 24px;
    width: 24px;
  }

  &:hover {
    opacity: 1;
  }
}

@media screen and (max-width: 999px) {
  .p-map {
    width: 100vw;
    // height: calc(100vh - 154px);
  }
  .p-list {
    width:100%;
    margin: auto;
    background-color: #FAFAFA;
    h1 {
      width: $pc-width;
      margin: 20px auto;
    }
    &--sort {
      width: $pc-width;
      padding-right: 10px;
      margin: 20px auto;
    }
    &--outline {
      margin: auto;
    }
  }
  .p-swapDisplay {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
@media screen and (max-width: 767px)  {
  .p-map {
    width: 100vw;
    height: calc(100vh - 144px);
  }
  .p-list {
    width:100%;
    margin: auto;
    background-color: #FAFAFA;
    h1 {
      max-width: $sp-width;
      max-width: 346px;
      width: 100%;
      padding: 15px 0;
      margin: auto;
      line-height: 1.5em;
    }
    &--condition {
        width: 100%;
        max-width: 346px;
        margin: auto;
      li {
        position: relative;
        justify-content: left;
        width: 100%;
        border:none;
        border-bottom: 1px solid #CCC;
        border-radius: 0;
        padding: 0;
        margin: 0;
        background-color: #FAFAFA;
        img {
          position: absolute;
          right:0px;
        }
      }
    }
    &--sortOrderBlock {
      flex-direction: column;
    }
    &--sort {
      max-width: 100%;
      padding: 0 15px;
      margin: 20px auto;
      flex-wrap: wrap;

      &--count {
        margin-bottom: 36px;
      }

      &--order {
        justify-content: flex-end;
        width: 100%;
        margin-top: 10px;
      }
    }
  &--outline {
    padding: 0 15px;
    max-width: 100%;
    margin: auto;
  }
  &--area--outline {
    max-width: $sp-width;
    margin: 20px auto;
  }
  &--breadcrumb--outline {
    padding: 0 15px;
    max-width: 100%;
    margin: 20px auto;
  }
  }
  .p-swapDisplay {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.c-container {
  width:100%;
  display: flex;
  .u-selectWrapper {
    width: 180px;
    height: 36px;
    background: #FFF;
    border: 1px solid #CCC;
    border-radius: 18px;
    overflow: hidden;
    position:relative;
    select {
      padding: 0 0 0 20px;
      width: 100%;
      height: 100%;
      font-size: 14px;
      border: 0;
      cursor: pointer;
      appearance: none;
      background: right 10px center no-repeat url(/static/img/icon-sort-4-s.png);
      background-size: 20px 19px;
    }
    &__s{
      width:120px;
    }
  }
}

</style>
